import {Injectable} from '@angular/core';
import {DcpApiService} from '@dcp/configurator';
import {ExploreSapConfig} from '@app/services/navigation/model/explore-sap-config.model';
import {Observable} from 'rxjs';
import {ContextualMainLinksConfig} from '@app/services/navigation/model/main-links-config.model';

@Injectable({
  providedIn: 'root'
})
export class DcpMastheadNavigationService {

  constructor(private dcpApiService: DcpApiService) {
  }

  getExploreSap(): Observable<ExploreSapConfig> {
    return this.dcpApiService.callApi<ExploreSapConfig>(
      'contextualNavigation',
      'exploreSap',
    )
  }

  getMainLinks(): Observable<ContextualMainLinksConfig> {
    return this.dcpApiService.callApi<ContextualMainLinksConfig>(
      'commerceUiAssets',
      'mainLinks'
    )
  }

  transformSubMenus(subMenuRows) {
    const subMenus = subMenuRows.map(row => ({
      subMenuLinkItems: row.subMenuLinkItems.map(item => ({
        category: item.category,
        url: item.url,
        items: item.items.map(subItem => ({
          title: subItem.title,
          url: subItem.url
        }))
      }))
    }));
    return JSON.stringify(subMenus)
  }

}

